import { type CSSProperties } from 'react';

interface Props {
  /** 0..1 charge. */
  fill: number;
  label?: string;
  /** Short status under the bar, e.g. "Faster than last time! ↑". */
  caption?: string;
  /** Green (good news) vs neutral caption. */
  captionGood?: boolean;
}

/** Spidey "web-shooter charge bar" — a gold bar with the spider riding the leading edge.
 *  Fills with reading speed (the WCPM proxy). Gentle: a low fill is never a "fail". */
export function SpeedMeter({ fill, label = '⚡ WEB SPEED', caption, captionGood }: Props) {
  const pct = Math.round(Math.max(0, Math.min(1, fill)) * 100);
  return (
    <div style={wrap}>
      <div style={labelStyle}>{label}</div>
      <div style={track}>
        <div style={{ ...barFill, width: `${pct}%` }} />
        <span style={{ ...spider, left: `${pct}%` }}>🕷️</span>
      </div>
      {caption && <div style={{ ...cap, color: captionGood ? 'var(--good)' : 'var(--ink-soft)' }}>{caption}</div>}
    </div>
  );
}

const wrap: CSSProperties = { width: 'min(440px, 86vw)', display: 'flex', flexDirection: 'column', gap: 6 };
const labelStyle: CSSProperties = { fontSize: 14, fontWeight: 800, color: 'var(--gold)', letterSpacing: 1 };
const track: CSSProperties = {
  position: 'relative',
  height: 22,
  borderRadius: 999,
  background: 'var(--frame)',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: 'var(--frame-edge)',
  overflow: 'visible',
};
const barFill: CSSProperties = {
  height: '100%',
  background: 'linear-gradient(90deg, var(--spidey-red), var(--gold))',
  borderRadius: 999,
  transition: 'width 0.6s cubic-bezier(0.22,1,0.36,1)',
};
const spider: CSSProperties = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: 22,
  transition: 'left 0.6s cubic-bezier(0.22,1,0.36,1)',
  pointerEvents: 'none',
};
const cap: CSSProperties = { fontSize: 15, fontWeight: 800 };
